import React, { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import MobileFriendlyBooking from "containers/Widgets/MobileFriendlyBooking";

const FloatingBookingWidget: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClose = () => {
    setIsExpanded(false);
  };

  // Collapsed state - vertical tab
  if (!isExpanded) {
    return (
      <a
        href="#book"
        onClick={(e) => {
          e.preventDefault();
          setIsExpanded(true);
        }}
        className="xl:hidden fixed top-3/4 -translate-y-1/2 right-0 z-[9999] bg-primary-6000 rounded-l-xl py-4 px-2 shadow-lg shadow-primary-700/30 hover:bg-primary-700 hover:px-3 hover:-translate-x-1 active:scale-95 transition-all duration-300 cursor-pointer select-none no-underline group animate-pulse hover:animate-none"
        style={{
          WebkitTapHighlightColor: 'transparent',
          touchAction: 'manipulation',
        }}
      >
        <div className="flex items-center gap-2">
          {/* Arrow indicator */}
          <svg className="w-4 h-4 text-white/70 group-hover:text-white transition-colors rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          <span
            className="text-white font-bold text-sm tracking-widest uppercase"
            style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
          >
            Book
          </span>
        </div>
      </a>
    );
  }

  // Expanded state - booking widget panel
  return (
    <>
      {/* Backdrop overlay - click to close */}
      <div
        className="xl:hidden fixed inset-0 z-40 bg-black/50 backdrop-blur-sm"
        onClick={handleClose}
      />
      <div className="xl:hidden fixed inset-0 z-[9999] overflow-y-auto p-4 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        <div className="flex justify-end mb-2">
          <button
            onClick={handleClose}
            className="bg-white text-neutral-500 hover:text-neutral-700 p-2 rounded-full shadow-lg hover:bg-neutral-50 transition-colors"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        <style>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <div className="bg-white rounded-2xl shadow-2xl border border-neutral-200 w-full max-w-md mx-auto sm:ml-auto sm:mr-4 p-4">
          <MobileFriendlyBooking />
        </div>
      </div>
    </>
  );
};

export default FloatingBookingWidget;
